import { useEffect } from "react";
import logger from "../utils/logger";

/**
 * useDeviceDataLoader Hook
 * Phase 1 Day 45 - Extract device data loading effects
 *
 * Manages initial device load and device-specific data loading on selection change.
 */
export function useDeviceDataLoader({
  loadInitialDevices,
  selectedDeviceId,
  isLoading,
  credentialsLoadStartTime,
  setCredentials,
  setActionHistory,
  setCredentialsLoaded,
  loadDataForDevice,
}) {
  // Effect to load initial devices on mount and when installation changes
  useEffect(() => {
    loadInitialDevices();
  }, [loadInitialDevices]); // Reload when installation changes (via loadInitialDevices dependency)

  // Effect to load data when selection changes OR after initial load completes
  useEffect(() => {
    // --- (useEffect logic remains unchanged) ---
    if (isLoading) {
      logger.log(
        "useEffect[selectedDeviceId]: Skipping, initial load in progress."
      );
      return;
    }
    if (!selectedDeviceId) {
      logger.log("useEffect[selectedDeviceId]: Selection cleared.");
      // Don't clear deviceStates - they should persist for quick device switching
      setCredentials([]);
      setActionHistory([]);
      setCredentialsLoaded(false);
      return;
    }
    // Reset credentials loaded state when switching devices
    logger.log(
      `[credentialsLoaded] 🔄 Resetting to false for device switch to ${selectedDeviceId}`
    );
    credentialsLoadStartTime.current = Date.now();
    setCredentialsLoaded(false);
    logger.log(
      `useEffect[selectedDeviceId]: Loading data for ${selectedDeviceId}.`
    );
    loadDataForDevice(selectedDeviceId);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDeviceId]);
  // isLoading is intentionally excluded - we check it for early return but don't want to retrigger when it changes
  // loadDataForDevice is intentionally excluded - it should be stable from useDataLoader
}
